import React from 'react';
import { EstimatorPage as SharedEstimatorPage } from '@apply/estimator';
import { Footer } from '../common_v2/components/Footer';
import { LogoLink } from '../common_v2/components/LogoLink';
import './scss/estimatorpage.scss';

export const EstimatorPage: React.FC = () => (
    <div className='est-outer'>
        <div className='est-topbar'>
            <LogoLink />
        </div>
        <SharedEstimatorPage />
        <Footer />
    </div>
);
